
/** 
 * Import Ionic and others
 */
import { Injectable, ViewChild } from '@angular/core';
import { App, Nav, AlertController, LoadingController, Events, Platform, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AccountLoginPage } from '../pages/account-login/account-login';

/**
 * Import Google
 */
import * as googleConfig from '../config/google.json';

/**
 * Import Facebook
 */
import { Facebook, GooglePlus } from 'ionic-native';
let facebook: any = Facebook;
let googleplus: any = GooglePlus;

/**
 * Import Firebase
 */
import { Fb } from './firebase';

import sha256 from 'sha256';

/**
 * 
 * 
 * @export
 * @class User
 */
@Injectable()
export class User {
    @ViewChild(Nav) nav: Nav;
    /**
     * 
     * 
     * @type {LoadingController}
     * @memberOf User
     */
    loading: any;
    /**
     * 
     * 
     * @type {string}
     * @memberOf User
     */
    googleWebClient: string = 'AIzaSyAEgKIxRaAOY_8GXxhSo-1uKNsR570';

    /**
     * 
     * 
     * @type {string}
     * @memberOf User
     */
    googleScopes: string = 'profile email';

    /**
     * 
     * 
     * @type {any}
     * @memberOf User
     */
    facebookScopes: any = ['public_profile', 'email'];

    /**
     * 
     * 
     * @type {boolean}
     * @memberOf User
     */
    online: boolean = false;

    /**
     * 
     * 
     * @type {boolean}
     * @memberOf User
     */
    offline: boolean = false;
    fb: any;
    photoBLOB: any;

    /**
     * Creates an instance of User.
     * 
     * 
     * @memberOf User
     */
    constructor(
        public app: App,
        public platform: Platform,
        public alert: AlertController,
        public loader: LoadingController,
        public toast: ToastController,
        public storage: Storage,
        public fire: Fb,
        public events: Events

    ) {
        this.googleWebClient = googleConfig.webClient;
        this.loading = loader.create({
            content: 'Please wait..',
            duration: 10000,
            dismissOnPageChange: true
        });
        this.fb = fire.instance();
    }

    /**
     * Database
     * 
     * @returns firebase.database()
     * 
     * @memberOf User
     */
    db() {
        return this.fb.database();
    }


    /**
     * Profile
     * 
     * @returns firebase.auth().currentUser
     * 
     * @memberOf User
     */
    profile() {
        return this.fb.auth().currentUser;
    }


    /**
     * Profile Sync
     * With firebase database
     * Syncs user profile in realtime database since we don't have access to firebase user details
     * This way we can work with user details in future
     * 
     * @memberOf User
     */
    profileSync() {
        let unnamed = 'Unnamed';

        // if user is coming from signup form, he doesnt have a name. let's change it
        if (!this.profile().displayName) {
            this.profile().updateProfile({
                displayName: unnamed
            });
        }

        this.ref().then((path) => {
            let ref = path + '/profile';
            let profile = {
                uid: this.profile().uid,
                displayName: this.profile().displayName || unnamed,
                email: this.profile().email,
                photoURL: this.profile().photoURL
            }
            this.db().ref(ref).update(profile);
        });
    }

    updateListings(listings:any) {
        let unnamed = 'Unnamed';

        this.ref().then((path) => {
            let ref = path + '/profile';
            let profile = {
                uid: this.profile().uid,
                displayName: this.profile().displayName || unnamed,
                email: this.profile().email,
                photoURL: this.profile().photoURL,
                listings: listings
            }
            this.db().ref(ref).update(profile);
        });
    }

    updateConversion() {
        this.ref().then((path) => {
            let ref = path + '/profile';
            let profile = {
                uid: this.profile().uid,
                converted: true
            }
            this.db().ref(ref).update(profile);
        });
    }


    ref() {
        return new Promise((resolve, reject) => {
            // this.isConnected().then((status) => {
            if (this.profile())
                //if (status) {
                resolve('users/' + this.profile().uid);
            //}
            // });
        });
    }
    authAnonymous()
    {
        this.fb.auth().signInAnonymously()
        .catch(function(error) {
        // Handle errors
        });
    }
    /**
     * Auth With Google
     * 
     * @param {any} cbSuccess
     * @param {any} cbError
     * @returns success: authData.idToken, authData.accessToken
     * 
     * @memberOf User
     */
    authWithGoogle(cbSuccess, cbError) {
        let options: any = {
            'scopes': this.googleScopes, // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
            'webClientId': this.googleWebClient,
            'offline': true, // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
        }
        console.debug('authWithGoogle options:');
        console.debug(options);
        // note for iOS the googleplus plugin requires ENABLE_BITCODE to be turned off in the Xcode
        googleplus.login(options, cbSuccess, cbError).then(cbSuccess).catch(cbError);
    }

    /**
     * Auth With Facebook
     * 
     * @param {any} cbSuccess
     * @param {any} cbError
     * @returns success: token
     * 
     * @memberOf User
     */
    authWithFacebook(cbSuccess, cbError) {
        facebook.getLoginStatus((res) => {
            if (res.status === 'connected') {
                cbSuccess(res.authResponse.accessToken);
            } else {
                facebook.login(this.facebookScopes, (user) => {
                    facebook.getAccessToken(cbSuccess, cbError);
                },
                    cbError
                );
            }
        }, cbError);
    }

    /**
     * 
     * 
     * @static
     * 
     * @memberOf User
     */
    logout() {
        // give a time to menu closing animation
        setTimeout(() => {
            this.app.getActiveNav().setRoot(AccountLoginPage);
            try {
                // logout facebook native
                facebook.logout();
                // logout firebase
                this.fb.auth().signOut();
                // logout google native
                // it can show error in dev mode, using -lc
                // try in production mode (eg. ionic run android --prod)
                googleplus.logout();
            } catch (e) { }

        }, 300);
    }

    /**
     * Error handler
     * 
     * you can translate here
     * 
     * @static
     * @param {any} code
     * @param {any} message
     * @returns {object} title, message
     */
    static errorHandler(code, message) {
        let result: any = { title: 'Fail', message: message };
        switch (code) {
            case 'auth/account-exists-with-different-credential':
                result = { title: 'Oops', message: 'It already exists an account with the email address asserted by the credential. Login first before connecting with other accounts.' };
                break;
            // case 'auth/user-not-found':
            //   result = { title: 'Atenção', message: 'Usuário não encontrado.' };
            //   break;
            // case 'auth/wrong-password':
            //   result = { title: 'Atenção', message: 'Password incorreta.' };
            //   break;
            // case 'auth/weak-password':
            //   result = { title: 'Atenção', message: 'A password deve ter no mínimo 6 caracteres.' };
            //   break;
            // case 'auth/invalid-email':
            //   result = { title: 'Atenção', message: 'O endereço de email está mal formatado.' };
            //   break;
            // case 'auth/email-already-in-use':
            //   result = { title: 'Atenção', message: 'Este endereço de email já está sendo utilizado.' };
            // case 'auth/requires-recent-login':
            //   result = { title: 'Atenção', message: 'Esta é uma operação sensível e requer que você efetue o login novamente.' };
            //   break;
        }
        return result;
    }


    /**
     * Show Alert
     * 
     * @param {any} title
     * @param {any} subtitle
     * 
     * @memberOf User
     */
    showAlert(title, subtitle) {
        let alert = this.alert.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        });
        setTimeout(() => {
            alert.present();
        });
    }


    gcmToken() {
        if (this.profile()) {
            try {
                window['FirebasePlugin'].getToken((token) => {
                    this.setGCMToken(token);
                }, (error) => {
                    console.error(error);
                });
                window['FirebasePlugin'].onTokenRefresh((token) => {
                    this.setGCMToken(token);
                }, (error) => {
                    console.error(error);
                });
            } catch (e) { };
        }
    }


    setGCMToken(token) {
        this.ref().then((path) => {
            this.db().ref(path + '/token_gcm').set(token);
        });
    }

    presence() {
        console.info('user:presence');
        let connectedRef = this.db().ref('.info/connected');
        connectedRef.on('value', (snap) => {
            if (snap.val() === true) {
                if (this.offline) {
                    this.online = true;
                    this.offline = false;
                }
                this.events.publish('user:online');
            } else {
                if (this.online) {
                    this.online = false;
                    this.offline = true;
                }
                this.events.publish('user:offline');
            }

        });

        return this.fb.auth().onAuthStateChanged((user) => {
            if (user) {
                this.storage.set('firetask:user:connected', true);
                this.events.publish('user:loggedIn', user);
            } else {
                this.storage.set('firetask:user:connected', false);
                this.events.publish('user:loggedOut');
            }
        });
    }

    isConnected() {
        return new Promise((resolve, reject) => {
            this.storage.get('firetask:user:connected').then((status) => {
                if (status)
                    resolve(true);
                else
                    resolve(false);
            });
        });
    }

    isNotConnected() {
        return new Promise((resolve, reject) => {
            this.storage.get('firetask:user:connected').then((status) => {
                if (status)
                    resolve(false);
                else
                    resolve(true);
            });
        });
    }

    accounting() {
        console.info('user:accounting');
        // try to get the profile or save if it does not exist
        this.ref().then((path) => {
            this.db().ref(path + '/profile').once('value').then((snapshot) => {
                // update user profile
                this.profileSync();
                if (!snapshot.val()) {
                    // add +1 to new user stats
                    this.countStats();
                }
            });
        });
    }



    /**
     * Count stats
     * 
     * add +1 to stats/users when its a new user
     * 
     * @returns {*}
     * 
     * @memberOf User
     */
    countStats(): any {
        console.log('countStats: new user');
        var stats = this.db().ref('stats/users');
        stats.transaction((current) => {
            return current + 1;
        }).catch((e) => {
            console.error(e);
        });
    }



    /**
     * Profile Image Storage
     *
     * @param {string} path
     * @return {string} downloadURL
     *
     * @memberOf User
     */
    profileImageStorage(path: string) {
        console.debug('profileImageStorage:start');
        return new Promise((resolve, reject) => {
            var readFile: any = window['resolveLocalFileSystemURL'];
            readFile(path, (fileEntry) => {
                fileEntry.file((file) => {
                    const fileReader = new FileReader();
                    fileReader.onloadend = (result: any) => {
                        let arrayBuffer = result.target.result;
                        let blob = new Blob([new Uint8Array(arrayBuffer)], { type: 'image/jpeg' });
                        // Create a root reference
                        var storageRef = this.fb.storage().ref('profile/' + sha256(this.guid()));
                        var uploadTask = storageRef.put(blob);
                        this.photoBLOB = blob;
                        // Register three observers:
                        // 1. 'state_changed' observer, called any time the state changes
                        // 2. Error observer, called on failure
                        // 3. Completion observer, called on successful completion
                        console.log('Upload started:');
                        uploadTask.on('state_changed', (snapshot) => {
                            // Observe state change events such as progress, pause, and resume
                            // See below for more detail
                            let percent = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                            console.log(percent + "% done");
                        }, (e) => {
                            // Handle unsuccessful uploads
                            console.error(e);
                            console.debug('profileImageStorage:end');
                            reject(e);
                        }, () => {
                            // Handle successful uploads on complete
                            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                            var downloadURL = uploadTask.snapshot.downloadURL;
                            console.info('Profile pic URL:' + downloadURL);
                            console.info('Profile pic URI:' + path);
                            console.debug('profileImageStorage:end');
                            //  this.updateProfile(); //persist on API
                            resolve(downloadURL);
                        });
                    };
                    fileReader.onerror = (e: any) => {
                        console.error(e);
                        reject(e);
                    };
                    fileReader.readAsArrayBuffer(file);
                }, (e) => { console.error(e); reject(e); });
            }, (e) => { console.error(e); reject(e); });
        });
    }


    /**
     * GUID
     *
     * @returns guid
     *
     * @memberOf User
     */
    guid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
            this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    /**
     * Get Profile Image 64
     *
     * Eg: show image profile imediatly after crop
     *
     * @returns Promise<base64data>
     *
     * @memberOf User
     */
    getProfileImage64(blob?: any) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const reader = new FileReader();
                const events = this.events;
                reader.readAsDataURL(blob || this.photoBLOB);
                reader.onloadend = function () {
                    let base64data = reader.result;
                    events.publish('user:photo64', base64data);
                    resolve(base64data);
                }
            }, 1000);
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/user.ts